import ReactDOM from "react-dom";
import RootProvider from "state/utils/createProvider";
import { tokenManager } from "coral-utility";

require("typeface-archivo");
require("typeface-roboto");

const nodeEnv = process.env.NODE_ENV;
tokenManager.register(`CORAL_APP_${nodeEnv}`);

ReactDOM.render(<RootProvider />, document.getElementById("root"));
